import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ConversationReportMessages = ActionButtonMessages &
  SidebarMessages &
  PopoverMessages &
  TableColumnsMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    filtersTitle: string;
    contact: string;
    contactPlaceholder: string;
    platform: string;
    workflow: string;
    queue: string;
    mainSubject: string;
    conversationStatus: string;
    hasUnread: string;
    supportByHuman: string;
    closedByHuman: string;
    issueSolved: string;
    conversationType: string;
    startDate: string;
    lastReceivedDate: string;
    lastInterationDate: string;
    firstAnswerDate: string;
    endDate: string;
    lastReactivation: string;
    lastReadDate: string;
    deletedDate: string;
    phone: string;
    csat: string;
    withoutCsat: string;
    attendant: string;
    conversationId: string;
    from: string;
    to: string;
    all: string;
    yes: string;
    no: string;
    statusAttending: string;
    statusWaiting: string;
    statusClosed: string;
    statusReactivated: string;
    typeMessage: string;
    typeCampaign: string;
    typeStatus: string;
    moreFilters: string;
    lessFilters: string;
    clearFilters: string;
    applyFilters: string;
    sortBy: string;
    sortDesc: string;
    sortAsc: string;
    export: string;
    newConversation: string;
    resultsTitle: string;
    emptyTitle: string;
    emptyDescription: string;
    loadError: string;
    openConversation: string;
    exportLimited: string;
    columnId: string;
    columnContact: string;
    columnPlatform: string;
    columnAttendant: string;
    columnWorkflow: string;
    columnQueue: string;
    columnStart: string;
    columnLastReceived: string;
    columnUnread: string;
    columnLastInteration: string;
    columnFirstAnswer: string;
    columnReactivations: string;
    columnCsat: string;
    columnIssueSolved: string;
    columnStatus: string;
    columnActions: string;
  };

export const CONVERSATION_REPORT_MESSAGES: ConversationReportMessages = {
  pageTitle: "Conversas",
  breadCrumbTitle: "Conversas",
  filtersTitle: "Filtros de pesquisa",
  contact: "Contato",
  contactPlaceholder: "Buscar contato",
  platform: "Plataforma",
  workflow: "Workflow",
  queue: "Fila",
  mainSubject: "Assunto principal",
  conversationStatus: "Status da conversa",
  hasUnread: "Possui não lidas",
  supportByHuman: "Suporte humano",
  closedByHuman: "Encerrada por humano",
  issueSolved: "Problema resolvido",
  conversationType: "Tipo de conversa",
  startDate: "Data de início",
  lastReceivedDate: "Última mensagem recebida",
  lastInterationDate: "Última interação",
  firstAnswerDate: "Primeira resposta",
  endDate: "Encerramento",
  lastReactivation: "Reativação",
  lastReadDate: "Última leitura",
  deletedDate: "Data de exclusão",
  phone: "Telefone",
  csat: "CSAT",
  withoutCsat: "Sem nota",
  attendant: "Atendente",
  conversationId: "ID da conversa",
  from: "De",
  to: "Até",
  all: "Todos",
  yes: "Sim",
  no: "Não",
  statusAttending: "Em atendimento",
  statusWaiting: "Aguardando",
  statusClosed: "Encerrada",
  statusReactivated: "Reativada",
  typeMessage: "Mensagem",
  typeCampaign: "Campanha",
  typeStatus: "Status",
  moreFilters: "Mais filtros",
  lessFilters: "Menos filtros",
  clearFilters: "Limpar filtros",
  applyFilters: "Filtrar",
  sortBy: "Ordenar por",
  sortDesc: "Decrescente",
  sortAsc: "Crescente",
  export: "Exportar",
  newConversation: "Nova conversa",
  resultsTitle: "Conversas",
  emptyTitle: "Nenhuma conversa encontrada",
  emptyDescription: "Ajuste os filtros e pesquise novamente.",
  loadError: "Não foi possível carregar as conversas.",
  openConversation: "Abrir conversa",
  exportLimited: "A exportação inclui no máximo 1000 conversas do filtro atual.",
  columnId: "ID",
  columnContact: "Contato",
  columnPlatform: "Plataforma",
  columnAttendant: "Atendente",
  columnWorkflow: "Workflow",
  columnQueue: "Fila",
  columnStart: "Início da conversa",
  columnLastReceived: "Última mensagem",
  columnUnread: "Não lidas",
  columnLastInteration: "Última interação",
  columnFirstAnswer: "Primeira resposta",
  columnReactivations: "Reativações",
  columnCsat: "CSAT",
  columnIssueSolved: "Problema resolvido",
  columnStatus: "Status",
  columnActions: "Ações",
  ...TABLE_COLUMNS_MESSAGES,
  ...POPOVER_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
